module.exports = {"TXTMOB_You":{"id":"TXTMOB_You","defaultMessage":"Εσύ"}}